import React from 'react';

import PropTypes from 'prop-types';

import DisabledPaymentMethod from 'apps/auth/components/common/paymentMethod/DisabledPaymentMethod';
import EnabledPaymentMethod from 'apps/auth/components/common/paymentMethod/EnabledPaymentMethod';
import { URL_IMAGES_BANKS } from 'apps/auth/constants/UrlConstants';
import { CANADA } from 'apps/auth/constants/WellKnownCountries';

const DcCards = ({
    cards,
    actionBanner,
    badge,
    getPaymentFlow,
    formName,
    filterCategories = [],
    paymentMethod,
    category,
    clickHandler,
    userCountryId,
    recipientType,
    paymentMethodCategory,
    submitRef,
    toCountryCode,
    toCurrencyCode,
    isIncomplete,
    popupRef,
}) => {
    return (
        <>
            {Array.isArray(cards) &&
                cards.length > 0 &&
                cards
                    .filter((c) => filterCategories.includes(c.categoryId))
                    .map((card) => {
                        const name = userCountryId === CANADA ? card.alias : `${card.alias} ·· ${card.description}`;
                        if (card?.temporarilyUnavailableSource) {
                            return (
                                <DisabledPaymentMethod
                                    key={card.code}
                                    formName={formName}
                                    name={name}
                                    description={userCountryId === CANADA ? card.sourceDescription : null}
                                    icon={!card.cardLogo ? 'card' : null}
                                    src={card.cardLogo ? `${URL_IMAGES_BANKS}/${card.cardLogo}.png` : null}
                                    method={paymentMethod?.method}
                                    code={card.code}
                                    diskVariant={card.cardLogo ? '' : 'tertiary'}
                                    withoutRadius={true}
                                    isDisabled={true}
                                    isInactive={true}
                                    temporarilyUnavailableReason={card?.temporarilyUnavailableReason}
                                    isTemporarilyUnavailableSource={card?.temporarilyUnavailableSource}
                                />
                            );
                        } else {
                            return (
                                <EnabledPaymentMethod
                                    card={card}
                                    key={card.code}
                                    name={name}
                                    description={userCountryId === CANADA ? card.sourceDescription : null}
                                    code={card.code}
                                    method={paymentMethod?.method}
                                    icon={!card.cardLogo ? 'card' : null}
                                    src={card.cardLogo ? `${URL_IMAGES_BANKS}/${card.cardLogo}.png` : null}
                                    diskVariant={card.cardLogo ? '' : 'tertiary'}
                                    clickHandler={clickHandler}
                                    badge={badge}
                                    actionBanner={actionBanner}
                                    getPaymentFlow={getPaymentFlow}
                                    recipientType={recipientType}
                                    paymentMethodCategory={paymentMethodCategory}
                                    toCountryCode={toCountryCode}
                                    toCurrencyCode={toCurrencyCode}
                                    isIncomplete={isIncomplete}
                                    popupRef={popupRef}
                                />
                            );
                        }
                    })}
            <EnabledPaymentMethod
                name={paymentMethod?.name}
                description={paymentMethod?.description}
                method={paymentMethod?.method}
                icon="card-plus"
                clickHandler={clickHandler}
                badge={badge}
                actionBanner={actionBanner}
                getPaymentFlow={getPaymentFlow}
                paymentMethodCategory={paymentMethodCategory}
                recipientType={recipientType}
                category={category}
                submitRef={submitRef}
                toCountryCode={toCountryCode}
                toCurrencyCode={toCurrencyCode}
                isIncomplete={isIncomplete}
                popupRef={popupRef}
            />
        </>
    );
};

DcCards.propTypes = {
    paymentMethod: PropTypes.object.isRequired,
    getPaymentFlow: PropTypes.func.isRequired,
    formName: PropTypes.string.isRequired,
    badge: PropTypes.string,
    actionBanner: PropTypes.string,
    clickHandler: PropTypes.func.isRequired,
    category: PropTypes.number.isRequired,
};

export default DcCards;
